import { render, staticRenderFns } from "./StockPurchaseOrderDiscrepancyItemsTable.vue?vue&type=template&id=2e27041c&scoped=true&"
import script from "./StockPurchaseOrderDiscrepancyItemsTable.vue?vue&type=script&lang=js&"
export * from "./StockPurchaseOrderDiscrepancyItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./StockPurchaseOrderDiscrepancyItemsTable.vue?vue&type=style&index=0&id=2e27041c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e27041c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardTitle,VCol,VDataTable,VRow,VTextField})
